import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Check as CheckIcon, Close as CloseIcon } from '@mui/icons-material';

const selectedSx = (paletteKey) => (theme) => ({
  '&.Mui-selected, &.Mui-selected:hover': {
    bgcolor: alpha(theme.palette[paletteKey].main, 0.12),
    color: theme.palette[paletteKey].dark,
    fontWeight: 600,
  },
});

/** Compact two-option attendance toggle (✓ Going / ✗ Out). `value` is true, false or null (no response). */
const RsvpToggle = ({
  value,
  onChange,
  disabled = false,
  error = null,
  yesLabel = 'Going',
  noLabel = 'Out',
  ariaLabel = 'Attendance',
}) => {
  const selected = value === true ? 'yes' : value === false ? 'no' : null;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0.5 }}>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={selected}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(_, next) => {
          if (next === null || next === selected) return;
          onChange(next === 'yes');
        }}
        sx={{ '& .MuiToggleButton-root': { textTransform: 'none', py: 0.25, px: 1.25, gap: 0.5, whiteSpace: 'nowrap' } }}
      >
        <ToggleButton value="yes" sx={selectedSx('success')}>
          <CheckIcon sx={{ fontSize: 16 }} />
          {yesLabel}
        </ToggleButton>
        <ToggleButton value="no" sx={selectedSx('error')}>
          <CloseIcon sx={{ fontSize: 16 }} />
          {noLabel}
        </ToggleButton>
      </ToggleButtonGroup>
      {error && (
        <Typography variant="caption" color="error" role="alert">
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default RsvpToggle;
